import { restrictedLanguages } from '../constant/form/form';
import { ASSIGNMENT_STATUS } from '../constant/enum/assignment_status';
import { PROJECT_STATUS } from '../constant/enum/project_status';
export const findPreference = (items, preference) => {
    if (!Array.isArray(items))
        return [];
    return items
        .filter(item => item.preference === preference)
        .map(item => item.id);
};
export const filterByPreference = (items, preference) => {
    if (!Array.isArray(items))
        return [];
    return items.filter(item => item.preference === preference);
};
export const getWordCount = (text = '') => {
    const words = text.trim().split(/\s+/g);
    if (!words[0].length)
        return 0;
    return words.length;
};
export const convertSocialLinksArrayToObject = (links) => {
    let count = 1;
    const result = {};
    links.forEach(link => {
        if (link.includes('facebook.com')) {
            result.facebook = link;
            return;
        }
        if (link.includes('linkedin.com')) {
            result.linkedin = link;
            return;
        }
        if (link.includes('twitter.com')) {
            result.twitter = link;
            return;
        }
        if (link.includes('instagram.com')) {
            result.instagram = link;
            return;
        }
        else {
            result[`other_${count}`] = link;
            count += 1;
            return;
        }
    });
    return result;
};
export const shallowEqual = (object1, object2) => {
    if (!object1 || !object2)
        return false;
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length)
        return false;
    for (const key of keys1) {
        if (JSON.stringify(object1[key]) !== JSON.stringify(object2[key])) {
            return false;
        }
    }
    return true;
};
const months = [
    'Jan',
    'Feb',
    'March',
    'Apr',
    'May',
    'Jun',
    'July',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
export const formatChartDataMonthly = (data = {}, role = 'writer') => {
    const results = [];
    Object.keys(data).forEach(m => {
        const key = parseInt(m);
        if (role === 'writer') {
            const request = {
                status: 'Requests',
                month: months[key],
                week: '',
                count: data[key].request || 0
            };
            const complete = {
                status: 'Completed',
                month: months[key],
                week: '',
                count: data[key].completed || 0
            };
            const approved = {
                status: 'Approved',
                month: months[key],
                week: '',
                count: data[key].passed || 0
            };
            results.push(request, complete, approved);
        }
        else {
            const wordCount = {
                status: 'Word count',
                month: months[key],
                week: '',
                count: data[key].word_count || 0
            };
            const wordCountPerDay = {
                status: 'Word count per day',
                month: months[key],
                week: '',
                count: data[key].word_count_per_day || 0
            };
            results.push(wordCount, wordCountPerDay);
        }
    });
    return results;
};
export const formatChartDataWeekly = (data = {}, role = 'writer') => {
    const results = [];
    Object.keys(data).forEach(m => {
        const _m = parseInt(m);
        Object.keys(data[_m]).forEach(w => {
            const _w = parseInt(w);
            if (role === 'writer') {
                const request = {
                    status: 'Requests',
                    month: months[_m],
                    week: `Week ${_w}`,
                    count: data[_m][_w].request || 0
                };
                const complete = {
                    status: 'Completed',
                    month: months[_m],
                    week: `Week ${_w}`,
                    count: data[_m][_w].completed || 0
                };
                const approved = {
                    status: 'Approved',
                    month: months[_m],
                    week: `Week ${_w}`,
                    count: data[_m][_w].passed || 0
                };
                results.push(request, complete, approved);
            }
            else {
                const wordCount = {
                    status: 'Word count',
                    month: months[_m],
                    week: `Week ${_w}`,
                    count: data[_m][_w].word_count || 0
                };
                const wordCountPerDay = {
                    status: 'Word count per day',
                    month: months[_m],
                    week: `Week ${_w}`,
                    count: data[_m][_w].word_count_per_day || 0
                };
                results.push(wordCount, wordCountPerDay);
            }
        });
    });
    return results;
};
export function linkify(inputText) {
    let replacedText;
    const replacePattern1 = /(\b(https?|ftp):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/gim;
    replacedText = inputText.replace(replacePattern1, '<a href="$1" target="_blank">$1</a>');
    const replacePattern2 = /(^|[^/])(www\.[\S]+(\b|$))/gim;
    replacedText = replacedText.replace(replacePattern2, '$1<a href="http://$2" target="_blank">$2</a>');
    const replacePattern3 = /(([a-zA-Z0-9\-_.])+@[a-zA-Z_]+?(\.[a-zA-Z]{2,6})+)/gim;
    replacedText = replacedText.replace(replacePattern3, '<a href="mailto:$1" target="_blank">$1</a>');
    return replacedText;
}
export const getRestrictedLanguages = (languages = [], restrictedLang = restrictedLanguages) => {
    if (restrictedLang.length === 0)
        return languages;
    const _languages = [];
    restrictedLang.forEach(lang => {
        const _lang = languages.find(l => l.title.toLowerCase() === lang.toLowerCase());
        if (_lang)
            _languages.push(_lang);
    });
    return _languages;
};
export const getCategoryBaseAssignmentStatus = (category, status) => {
    if (category === 'translation') {
        const assignmentStatus = { ...ASSIGNMENT_STATUS[status] };
        switch (status) {
            case ASSIGNMENT_STATUS.WRI_AWA.id:
                assignmentStatus.title = 'ATA';
                assignmentStatus.title_extended = 'ATA';
                break;
            case ASSIGNMENT_STATUS.WRI_WRK.id:
                assignmentStatus.title = 'Translating';
                assignmentStatus.title_extended = 'Translating';
                break;
            case ASSIGNMENT_STATUS.EDO_AWA.id:
            case ASSIGNMENT_STATUS.EDO_RJT.id:
                assignmentStatus.title = 'Translated';
                assignmentStatus.title_extended = 'Translated';
                break;
            default:
                break;
        }
        return assignmentStatus;
    }
    else if (category === 'design') {
        const assignmentStatus = { ...ASSIGNMENT_STATUS[status] };
        switch (status) {
            case ASSIGNMENT_STATUS.WRI_AWA.id:
                assignmentStatus.title = 'ADA';
                assignmentStatus.title_extended = 'ADA';
                break;
            case ASSIGNMENT_STATUS.WRI_WRK.id:
                assignmentStatus.title = 'Designing';
                assignmentStatus.title_extended = 'Designing';
                break;
            case ASSIGNMENT_STATUS.EDO_AWA.id:
            case ASSIGNMENT_STATUS.EDO_RJT.id:
                assignmentStatus.title = 'Designed';
                assignmentStatus.title_extended = 'Designed';
                break;
            default:
                break;
        }
        return assignmentStatus;
    }
    else if (category === 'others') {
        const assignmentStatus = { ...ASSIGNMENT_STATUS[status] };
        switch (status) {
            case ASSIGNMENT_STATUS.WRI_AWA.id:
                assignmentStatus.title = 'ACA';
                assignmentStatus.title_extended = 'ACA';
                break;
            case ASSIGNMENT_STATUS.WRI_WRK.id:
                assignmentStatus.title = 'Creating';
                assignmentStatus.title_extended = 'Creating';
                break;
            case ASSIGNMENT_STATUS.EDO_AWA.id:
            case ASSIGNMENT_STATUS.EDO_RJT.id:
                assignmentStatus.title = 'Created';
                assignmentStatus.title_extended = 'Created';
                break;
            default:
                break;
        }
        return assignmentStatus;
    }
    else {
        return ASSIGNMENT_STATUS[status];
    }
};
export const getCategoryBaseProjectStatus = (category, status) => {
    if (category === 'design') {
        const projectStatus = { ...PROJECT_STATUS[status] };
        if (status === PROJECT_STATUS.writing_progress.id) {
            projectStatus.title = 'Creation Progress';
            projectStatus.client_title = 'In Progress (Designing)';
        }
        if (status === PROJECT_STATUS.editing_progress.id) {
            projectStatus.title = 'Designed';
            projectStatus.client_title = 'Designed';
        }
        return projectStatus;
    }
    return PROJECT_STATUS[status];
};
export function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = src;
        script.async = true;
        script.onload = () => resolve(true);
        script.onerror = () => reject(false);
        document.body.appendChild(script);
    });
}
export function parseUrlString(urlString) {
    if (!urlString.includes(':~:text=')) {
        const result = urlString
            .split(',')
            .map((link) => link.trim())
            .filter(Boolean);
        return [...new Set(result)];
    }
    let result = urlString
        .split(/http|https/)
        .map((link) => link.trim())
        .filter(Boolean)
        .map((link) => {
        if (link.endsWith(','))
            return `http${link.replace(/,$/, '')}`;
        if (link.startsWith('s://') || link.startsWith('://'))
            return `http${link}`;
        return link;
    });
    result = [...new Set(result)];
    return result;
}
export const getModifiedEditorFeedbackData = ({ data, rework_areas, feedback_inputs, userRole, isOpsRole = false }) => {
    const list = [];
    const reverseScoresData = (scores = {}) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            grammar: (_a = scores === null || scores === void 0 ? void 0 : scores.language) !== null && _a !== void 0 ? _a : 0,
            irrelevant: (_b = scores === null || scores === void 0 ? void 0 : scores.content) !== null && _b !== void 0 ? _b : 0,
            contextuality: (_c = scores === null || scores === void 0 ? void 0 : scores.content) !== null && _c !== void 0 ? _c : 0,
            plagiarism: (_d = scores === null || scores === void 0 ? void 0 : scores.plagiarism) !== null && _d !== void 0 ? _d : 0,
            authenticity: (_e = scores === null || scores === void 0 ? void 0 : scores.plagiarism) !== null && _e !== void 0 ? _e : 0,
            outline: (_f = scores === null || scores === void 0 ? void 0 : scores.guideline) !== null && _f !== void 0 ? _f : 0,
            readability: (_g = scores === null || scores === void 0 ? void 0 : scores.readability) !== null && _g !== void 0 ? _g : 0
        };
    };
    data.feedback.forEach((_feedback) => {
        var _a, _b;
        const obj = {
            feedback_text: _feedback.feedback_text,
            full_name: _feedback.full_name,
            status: _feedback.status,
            avatar: _feedback.avatar,
            date_created: _feedback === null || _feedback === void 0 ? void 0 : _feedback.date,
            feedbacks: [],
            status_code: _feedback.status_code,
            reason: (_a = _feedback.reason) !== null && _a !== void 0 ? _a : '',
            rework_attachments: (_b = _feedback.rework_attachments) !== null && _b !== void 0 ? _b : [],
            is_ops_team: _feedback === null || _feedback === void 0 ? void 0 : _feedback.is_ops_team,
            scores: _feedback === null || _feedback === void 0 ? void 0 : _feedback.scores,
            flagged_creator: _feedback === null || _feedback === void 0 ? void 0 : _feedback.flagged_creator
        };
        _feedback.rework_areas_data.forEach((area) => {
            var _a;
            const _parentItem = rework_areas.find(item => {
                if (!isOpsRole && userRole !== 'editor') {
                    return item.key !== 'flag_creator' && item.id === area.id;
                }
                return item.id === area.id;
            });
            if (_parentItem) {
                const feedbackScores = reverseScoresData(_feedback.scores);
                const _score = (_a = feedbackScores === null || feedbackScores === void 0 ? void 0 : feedbackScores[_parentItem.key]) !== null && _a !== void 0 ? _a : 0;
                const _issues = [];
                area.inputs.forEach((id) => {
                    var _a, _b;
                    const _issue = (_b = (_a = feedback_inputs.find(_input => _input.id === id)) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '';
                    _issues.push(_issue);
                });
                obj.feedbacks.push({
                    title: _parentItem.title,
                    score: _score,
                    issues: _issues
                });
            }
        });
        list.push(obj);
    });
    return list;
};
export const getModifiedTimelineFeedbackData = ({ data: timeline, rework_areas, feedback_inputs }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const reverseScoresData = (scores = {}) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return {
            grammar: (_a = scores === null || scores === void 0 ? void 0 : scores.language) !== null && _a !== void 0 ? _a : 0,
            irrelevant: (_b = scores === null || scores === void 0 ? void 0 : scores.content) !== null && _b !== void 0 ? _b : 0,
            contextuality: (_c = scores === null || scores === void 0 ? void 0 : scores.content) !== null && _c !== void 0 ? _c : 0,
            plagiarism: (_d = scores === null || scores === void 0 ? void 0 : scores.plagiarism) !== null && _d !== void 0 ? _d : 0,
            authenticity: (_e = scores === null || scores === void 0 ? void 0 : scores.plagiarism) !== null && _e !== void 0 ? _e : 0,
            outline: (_f = scores === null || scores === void 0 ? void 0 : scores.guideline) !== null && _f !== void 0 ? _f : 0,
            readability: (_g = scores === null || scores === void 0 ? void 0 : scores.readability) !== null && _g !== void 0 ? _g : 0
        };
    };
    const obj = {
        feedback_text: (_a = timeline.feedback) !== null && _a !== void 0 ? _a : '',
        full_name: (_c = (_b = timeline.assigner_details) === null || _b === void 0 ? void 0 : _b.full_name) !== null && _c !== void 0 ? _c : '',
        status: 'feedback',
        avatar: (_e = (_d = timeline.assigner_details) === null || _d === void 0 ? void 0 : _d.avatar) !== null && _e !== void 0 ? _e : '',
        date_created: timeline === null || timeline === void 0 ? void 0 : timeline.created_at,
        feedbacks: [],
        status_code: timeline.status_code,
        reason: (_f = timeline.reason) !== null && _f !== void 0 ? _f : '',
        rework_attachments: (_g = timeline.rework_attachments) !== null && _g !== void 0 ? _g : []
    };
    timeline.rework_areas_data.forEach((area) => {
        var _a;
        const _parentItem = rework_areas.find(item => item.id === area.id);
        if (_parentItem) {
            const feedbackScores = reverseScoresData(timeline.scores);
            const _score = (_a = feedbackScores === null || feedbackScores === void 0 ? void 0 : feedbackScores[_parentItem.key]) !== null && _a !== void 0 ? _a : 0;
            const _issues = [];
            area.inputs.forEach((id) => {
                var _a, _b;
                const _issue = (_b = (_a = feedback_inputs.find(_input => _input.id === id)) === null || _a === void 0 ? void 0 : _a.title) !== null && _b !== void 0 ? _b : '';
                _issues.push(_issue);
            });
            obj.feedbacks.push({
                title: _parentItem.title,
                score: _score,
                issues: _issues
            });
        }
    });
    return obj;
};
export const validateRatingScores = (values, type) => {
    if (type === 'rework') {
        const _scores = [
            values.grammar,
            values.irrelevant,
            values.contextuality,
            values.plagiarism,
            values.authenticity,
            values.outline,
            values.readability
        ];
        const relevantScores = _scores.some(score => parseInt(score) <= 3);
        if (!relevantScores) {
            return false;
        }
        return true;
    }
    return true;
};
export const getVerticalKey = (selectedVerticalId, verticals) => {
    var _a, _b;
    return ((_b = (_a = verticals.find(vertical => vertical.id === selectedVerticalId)) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : '');
};
export const getProjectCategory = (categoryId, project_categories) => {
    var _a, _b;
    return ((_b = (_a = project_categories.find(category => category.id === categoryId)) === null || _a === void 0 ? void 0 : _a.key) !== null && _b !== void 0 ? _b : 'text');
};
export const generateReferenceFilesWithTags = (value, fields) => {
    const formFieldIds = [
        'reference_files_design_content',
        'reference_files_other_references',
        'reference_files_artworks',
        'reference_files_infographic_description',
        'reference_files_blog_content',
        'adapts_main_design',
        'references_brand_style_guide',
        'references_logo_files'
    ];
    const result = [];
    formFieldIds.forEach(formId => {
        var _a, _b, _c;
        if (((_a = value === null || value === void 0 ? void 0 : value[formId]) === null || _a === void 0 ? void 0 : _a.attachments) === undefined) {
            Array.isArray(value === null || value === void 0 ? void 0 : value[formId]) &&
                ((_b = value === null || value === void 0 ? void 0 : value[formId]) === null || _b === void 0 ? void 0 : _b.forEach((file) => {
                    var _a, _b;
                    result.push({
                        id: file.id,
                        tag: (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.find(field => field.id === formId)) === null || _a === void 0 ? void 0 : _a.tag) !== null && _b !== void 0 ? _b : ''
                    });
                }));
            return;
        }
        (_c = value === null || value === void 0 ? void 0 : value[formId]) === null || _c === void 0 ? void 0 : _c.attachments.forEach((file) => {
            var _a, _b;
            result.push({
                id: file.id,
                tag: (_b = (_a = fields === null || fields === void 0 ? void 0 : fields.find(field => field.id === formId)) === null || _a === void 0 ? void 0 : _a.tag) !== null && _b !== void 0 ? _b : ''
            });
        });
    });
    return result;
};
export const generateReferenceFilesWithTagsProject = (value, formFields) => {
    const formFieldIds = ['references_logo_files', 'references_brand_style_guide'];
    const result = [];
    formFieldIds.forEach(formId => {
        var _a;
        const _attachments = value === null || value === void 0 ? void 0 : value[formId];
        (_a = _attachments === null || _attachments === void 0 ? void 0 : _attachments.attachments) === null || _a === void 0 ? void 0 : _a.forEach((file) => {
            var _a, _b, _c;
            result.push({
                id: file.id,
                tag: (_c = (_b = (_a = formFields === null || formFields === void 0 ? void 0 : formFields.brandGuidelines) === null || _a === void 0 ? void 0 : _a.find(assign => assign.id === formId)) === null || _b === void 0 ? void 0 : _b.tag) !== null && _c !== void 0 ? _c : '',
                name: file.name,
                type: ''
            });
        });
    });
    return result;
};
export const getFilteredVisualOptions = (options, selectedDesignType) => {
    if (selectedDesignType) {
        return options.filter(option => { var _a; return ((_a = option === null || option === void 0 ? void 0 : option.type) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === selectedDesignType.toLowerCase(); });
    }
    return options;
};
export const getReworkReasons = (category) => {
    switch (category) {
        case 'design':
            return [
                'design_layout_and_color',
                'design_content_copy_text',
                'design_visual_elements',
                'design_originality',
                'design_brief_guidelines'
            ];
        case 'text':
            return ['grammar', 'irrelevant', 'outline', 'initiative'];
        case 'translation':
            return [
                'grammar',
                'contextuality',
                'authenticity',
                'readability',
                'outline'
            ];
        case 'others':
            return [];
        default:
            return [];
    }
};
export const getFirstLetterFromName = (firstName, lastNames) => {
    const firstNameLetter = firstName.charAt(0) || '';
    const lastNamesLetter = lastNames.charAt(0) || '';
    return `${firstNameLetter.toUpperCase()}${lastNamesLetter.toUpperCase()}`;
};
export const getFullName = (firstName, lastName) => {
    if (!firstName)
        return lastName;
    if (!lastName)
        return firstName;
    return `${firstName} ${lastName}`;
};
export function formatBytesToHumanReadableString(bytes, decimals = 2) {
    if (bytes === 0)
        return '0 Bytes';
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['bytes', 'kb', 'mb', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + sizes[i];
}
export const areTwoArrayValuesSame = (firstArray, secondArray, equalityChecker = (a1, a2) => a1 === a2) => {
    if (!Array.isArray(firstArray) ||
        !Array.isArray(secondArray) ||
        firstArray.length !== secondArray.length)
        return false;
    return firstArray.every((firstItem, index) => {
        const secondItem = secondArray[index];
        return equalityChecker(firstItem, secondItem);
    });
};
export function onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
}
export const getRedirectLinkOriginString = ({ currentHostname, currentOrigin, portalForRedirection, currentPortalName }) => {
    const portalToPortsMapping = {
        operations: '3002',
        business: '3001',
        creators: '3000'
    };
    let redirectLink;
    if (currentHostname === 'localhost') {
        redirectLink = currentOrigin.replace(portalToPortsMapping[currentPortalName], portalToPortsMapping[portalForRedirection]);
    }
    else {
        redirectLink = currentOrigin.replace(currentPortalName, portalForRedirection);
    }
    return redirectLink;
};
export const getShouldDisableField = (fieldValue) => {
    if ([null, undefined, ''].includes(fieldValue))
        return false;
    if (Array.isArray(fieldValue) && fieldValue.length === 0)
        return false;
    if (!Array.isArray(fieldValue) &&
        typeof fieldValue === 'object' &&
        Object.keys(fieldValue).length === 0)
        return false;
    if (!Array.isArray(fieldValue) &&
        typeof fieldValue === 'object' &&
        Object.keys(fieldValue).length > 0) {
        if (getShouldDisableField(fieldValue.comment))
            return true;
        if (getShouldDisableField(fieldValue.richText))
            return true;
        if (getShouldDisableField(fieldValue.richText))
            return true;
        if (getShouldDisableField(fieldValue.loomUrls))
            return true;
        return false;
    }
    return true;
};
//# sourceMappingURL=misc.js.map